<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<section #element *ngIf="showing"
         [attr.aria-describedby]="bodyId"
         [attr.aria-labelledby]="headingId"
         [ngClass]="classPopup"
         [ngStyle]="stylePopup"
         class="slds-popover"
         role="dialog">

  <button (click)="onClose()"
          [id]="closeId"
          [ngClass]="classButton"
          class="slds-button slds-button_icon slds-button_icon-small slds-float_right slds-popover__close"
          title="Close">
    <svg aria-hidden="true" class="slds-button__icon">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"/>
    </svg>
    <span class="slds-assistive-text">Close</span>
  </button>

  <header class="slds-popover__header">
    <div class="slds-media slds-media_center slds-has-flexi-truncate ">
      <div class="slds-media__figure">
        <span [ngClass]="classContainer"
              class="slds-icon_container">
          <svg [ngClass]="classIcon" aria-hidden="true"
               class="slds-icon slds-icon_x-small">
            <use [attr.xlink:href]="iconHref"/>
          </svg>
        </span>
      </div>
      <div class="slds-media__body">
        <h2 [id]="headingId"
            [title]="heading"
            class="slds-truncate slds-text-heading_small">{{heading}}</h2>
      </div>
    </div>
  </header>

  <div [id]="bodyId" class="slds-popover__body">
    <p style="white-space: pre">{{bodyText}}</p>
  </div>
</section>
